import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefresh32 = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12 14V12H9.09C10.47 9.61 13.05 8 16 8C19.72 8 22.85 10.56 23.74 14L25.8 14C24.87 9.44 20.84 6 16 6C12.73 6 9.82 7.58 8 10.01V8H6L6 14H12Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20 18V20L22.91 20C21.53 22.39 18.95 24 16 24C12.28 24 9.15001 21.44 8.26001 18H6.20001C7.13001 22.56 11.16 26 16 26C19.27 26 22.18 24.42 24 21.99V24L26 24V18L20 18Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgRefresh32);
export default ForwardRef;
